<script lang="ts" setup>
import type { DetailsRedSpan } from '@autobid/ui/types/components/CarDetails'
import { computed } from 'vue'

interface Props {
  text: string | DetailsRedSpan
  label?: string
}

const props = defineProps<Props>()

const isPdfPage = inject('isPdfPage', false)
const { APP_ID } = useRuntimeConfig().public
const isBMW = computed(() => [14, 17].includes(APP_ID))

function getTextData() {
  const isLink
    = typeof props.text === 'string' ? props.text.startsWith('http') : false

  return { isLink }
}
const { isLink } = getTextData()
</script>

<template>
  <a
    v-if="isLink && typeof text === 'string'"
    :href="text"
    target="_blank"
    rel="nofollow"
    class="inline-flex"
  >
    <span
      v-if="isPdfPage"
      class="break-all"
      :class="{
        'rounded bg-primary px-2 py-1 text-sm text-onPrimary': label,
      }"
    >
      {{ label ?? text }}
    </span>

    <elements-button v-else as="span" size="tiny" class="mt-1 md:!w-auto">
      {{ label ?? text }}
    </elements-button>
  </a>
  <span v-else class="whitespace-pre-line">
    <span
      v-if="
        typeof text === 'object' && 'type' in text && text.type === 'redSpan'
      "
      :class="{ redSpan: isBMW }"
    >
      {{ text.value }}
    </span>
    <span v-else>{{ text }}</span>
  </span>
</template>

<style lang="scss" scoped>
.redSpan {
  font-weight: 700;
  color: red;
}
</style>
